export const ZAVA_VIDEO_CONSULTATION_REDIRECT_URI =
  'gkv.zavamed.com/termin-auswahl/?utm_source=shop-apotheke&utm_medium=web&utm_term=sync';
